import Card from "../../../../../../componentLibrary/Card";
import GripHandle from "../../../../../../componentLibrary/GripHandle";
import Input from "../../../../../../componentLibrary/Input";
import type {
  RatingScaleQuestionI,
  ToolboxQuestionI,
} from "../../../../../../types";

export default function RatingScaleQuestionCard({
  question,
  onChange,
  onRemove,
  index,
}: {
  question: RatingScaleQuestionI;
  onChange: (q: ToolboxQuestionI) => void;
  onRemove?: () => void;
  index?: number;
}) {
  const updateField = (field: string, value: unknown) =>
    onChange({
      ...question,
      content: { ...question.content, [field]: value },
    } as ToolboxQuestionI);

  return (
    <Card
      title={
        <span className="flex items-center gap-2">
          <GripHandle className="fill-gray-300 shrink-0" />
          {index !== undefined
            ? `Q${index + 1} · Rating Scale`
            : "Rating Scale"}
        </span>
      }
      onClose={onRemove}
    >
      <div className="space-y-2 mt-1">
        <Input
          label="Variable name"
          placeholder="e.g. sleep_hours_needed"
          value={question.variableName}
          onChange={(e) =>
            onChange({
              ...question,
              variableName: e.target.value,
            } as ToolboxQuestionI)
          }
        />
        <Input
          label="Label"
          placeholder="e.g. Rate your stress level"
          value={question.content?.label ?? ""}
          onChange={(e) => updateField("label", e.target.value)}
        />
        <Input
          label="Scale (max value)"
          type="number"
          placeholder="5"
          value={String(question.content?.scale ?? 5)}
          onChange={(e) => updateField("scale", Number(e.target.value))}
        />
        <Input
          label="Min label (optional)"
          placeholder="e.g. Not at all"
          value={question.content?.minLabel ?? ""}
          onChange={(e) => updateField("minLabel", e.target.value)}
        />
        <Input
          label="Max label (optional)"
          placeholder="e.g. Extremely"
          value={question.content?.maxLabel ?? ""}
          onChange={(e) => updateField("maxLabel", e.target.value)}
        />
      </div>
    </Card>
  );
}
